import { Link } from '@material-ui/core';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import React from 'react';
import Image from '../../atoms/Image';
import Typography from '../../atoms/Typography/Typography';
const useStyles = makeStyles({
  root: {
    border: 0,
    backgroundImage: 'url("../../images/image/spec_1_2.jpeg")',
    backgroundSize: 'cover',
    height: '100vh',
    marginTop: '-160px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',

    '@media only screen and (max-width: 768px)': {
      marginTop: '-64px',
    },
  },
  image: {
    zIndex: -2,
    top: '-80px',
    position: 'absolute',
    width: '100%',
    minWidth: '1280px',
  },
  filter: {
    backgroundColor: 'rgba(0,0,0,0.40)',
    top: 0,
    position: 'fixed',
    width: '100%',
    height: '100vh',
  },

  /////
  mainRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '80vh',
    zIndex: 1,

    '@media only screen and (max-width: 768px)': {
      height: '60vh',
    },
  },
  mainText: {
    fontFamily: 'Helvetica',
    fontSize: '78px',
    lineHeight: '1.2',
    textAlign: 'left',
    color: '#f4f4f4',
    '@media only screen and (max-width: 768px)': {
      fontSize: '50px',
    },
    // border: 'solid 3px yellow',
  },
  subText: {
    fontFamily: 'Pretendard',
    fontSize: '20px',
    marginTop: '20px',
    textAlign: 'left',
    color: '#f4f4f4',
    '@media only screen and (max-width: 768px)': {
      fontSize: '14px',
    },
    // border: 'solid 3px green',
  },
  mainBox: {
    position: 'fixed',
    top: '30%',
    width: '50%',
    display: 'flex',
    flexDirection: 'column',

    '@media only screen and (max-width: 768px)': {
      top: '30%',
    },
    '@media only screen and (max-width: 425px)': {
      top: '80px',
      width: '90%',
    },
  },
  bottomBox: {
    display: 'flex',
    width: '100%',
    // marginTop: '130px',
    justifyContent: 'space-around',
    maxWidth: '800px',
    position: 'fixed',
    bottom: '32px',
    // '@media only screen and (max-width: 768px)': {
    //   alignItems: 'left',
    // },
    '@media only screen and (max-width: 767px)': {
      flexDirection: 'column',
      minWidth: '0px',
      width: '65%',
      alignItems: 'left',
      bottom: '0',
    },
  },
  img: {
    width: '60px',
    marginRight: '32px',
    '@media only screen and (max-width: 900px)': {
      width: '40px',
      marginRight: '12px',
    },
  },
  btnBox: {
    display: 'flex',
    alignItems: 'center',
    '@media only screen and (max-width: 900px)': {
      margin: '20px 0',
    },
  },
  btnText: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#f4f4f4',
    '@media only screen and (max-width: 300px)': {
      fontSize: '14px',
    },
  },
  homeBox: {
    display: 'flex',
    flexDirection: 'column',
  },
  icon: {
    color: 'white',
  },
});

export default function HomePage() {
  const classes = useStyles();

  // function goKitri() {
  //   window.location.href('http://www.kitri.re.kr/kitri/news/01edu_it_list.web');
  // }

  return (
    <Box className={classes.root}>
      <Box className={classes.filter} />
      <Box className={classes.mainRoot}>
        <Box className={classes.mainBox}>
          <Typography className={classes.mainText}>BEST</Typography>
          <Typography className={classes.mainText}>OF</Typography>
          <Typography className={classes.mainText}>THE BEST</Typography>
          <Typography className={classes.subText}>Next-generation security leader training program</Typography>
        </Box>

        <Box className={classes.bottomBox}>
          <Box className={classes.btnBox}>
            <Image className={classes.img} src='/images/icon/phoneicon2x.png' alt='call Image' />
            <Link href='tel:070-7093-9820' className={classes.btnText}>
              070-7093-9820
            </Link>
          </Box>
          <Box className={classes.btnBox}>
            <Image className={classes.img} src='/images/icon/mailicon2x.png' alt='message Image' />
            <Link href='mailto:bob@kitri.re.kr' className={classes.btnText}>
              bob@kitri.re.kr
            </Link>
          </Box>
          <Box className={classes.btnBox}>
            <Image className={classes.img} src='/images/icon/homeicon2x.png' alt='home Image' />
            <Box className={classes.homeBox}>
              <Box style={{ display: 'flex' }}>
                <Link href='http://www.kitri.re.kr/kitri/news/01edu_it_list.web' className={classes.btnText}>
                  KITRI
                </Link>
                <ArrowRightAltIcon className={classes.icon} />
              </Box>
              <Box style={{ display: 'flex' }}>
                <Link href='https://www.cyberguardians.or.kr/main.do;jsessionid=51D157B224FA295404C523D54E9E4751' className={classes.btnText}>
                  Cyber guardians
                </Link>
                <ArrowRightAltIcon className={classes.icon} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
